/** Coverage tab (A7Y-4883): how much of the corpus has volume, difficulty, SERP and Apple popularity data. */
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@a7y/tailwind-catalyst';
import type { KeywordDatabaseCoverage } from '@a7y/types';
import { formatInt, formatPct } from '../format';

const STORE_LABEL = { appstore: 'App Store', playstore: 'Play Store', all: 'All stores' } as const;

function Share({ part, whole }: { part: number; whole: number }) {
  return (
    <TableCell className="tabular-nums">{`${formatInt(part)} (${formatPct(part, whole)})`}</TableCell>
  );
}

export function CoverageTab({ coverage }: { coverage: KeywordDatabaseCoverage }) {
  return (
    <div className="space-y-3">
      <p className="text-xs text-zinc-500 dark:text-zinc-400">
        Volume and Apple popularity are keyed by term and storefront, so a Play keyword counts as
        covered when the same term and storefront has Apple popularity. Difficulty and SERP are
        keyed by keyword id.
      </p>
      <Table dense striped data-testid="coverage-table">
        <TableHead>
          <TableRow>
            <TableHeader>Store</TableHeader>
            <TableHeader>Keywords</TableHeader>
            <TableHeader>With volume (term, country)</TableHeader>
            <TableHeader>With difficulty (keyword_id)</TableHeader>
            <TableHeader>With SERP (keyword_id)</TableHeader>
            <TableHeader>With Apple popularity (term, country)</TableHeader>
          </TableRow>
        </TableHead>
        <TableBody>
          {coverage.rows.map((r) => (
            <TableRow key={r.store} data-testid={`coverage-row-${r.store}`}>
              <TableCell className="font-medium">{STORE_LABEL[r.store]}</TableCell>
              <TableCell className="tabular-nums">{formatInt(r.total)}</TableCell>
              <Share part={r.withVolume} whole={r.total} />
              <Share part={r.withDifficulty} whole={r.total} />
              <Share part={r.withSerp} whole={r.total} />
              <Share part={r.withApplePopularity} whole={r.total} />
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  );
}
